export class Reconciliation {
    id = -1;
    name = '';
    handle = '';

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.name = data.name ?? '';
        this.handle = data.handle ?? '';
        return this;
    }
}
